import * as angular from "angular";
import {ApiUrl} from "../../models/app-config.model";

export interface TenantConfigurationService {
    isCleverSSOEnabled: (districtId: string) => angular.IPromise<boolean>;
    enableClever: (districtId: string) => angular.IPromise<number>;
}

/* @ngInject */
export function tenantConfigurationService(API_URL: ApiUrl, $http: angular.IHttpService,
        $q: angular.IQService): TenantConfigurationService {
    let handleErrorResponse = (errorResponse): any => {
        if (errorResponse && errorResponse.status === 404) {
            return [];
        }
        return $q.reject(errorResponse);
    };

    let headers = {
        "Content-Type": "application/json"
    };

    return {
        enableClever: (districtId: string): angular.IPromise<number> => {
            return $http.post(`${API_URL.enableClever.replace(/\:districtId/, districtId)}`, null, { headers })
                .then((response: {status: number}) => {
                    return response.status;
                }, handleErrorResponse);
        },
        isCleverSSOEnabled: (districtId: string): angular.IPromise<boolean> => {
            return $http.get(`${API_URL.cleverEnabled.replace(/\:districtId/, districtId)}`)
                .then((response: {data: {enabled: boolean}}) => {
                    return response.data.enabled;
                }, handleErrorResponse);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/services/tenant-configuration/tenant-configuration.service.ts